<template>
   <Tooltip
      class="min-w-0 max-w-full"
      placement="bottom"
      interactive
      anchor-to-pointer
      :text="isTruncated ? text : undefined"
   >
      <span ref="textElement" class="block truncate">{{ text }}</span>
   </Tooltip>
</template>

<script lang="ts" setup>
import { nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue'

type Props = {
   text?: string
}

const props = defineProps<Props>()

const textElement = ref<HTMLElement>()
const isTruncated = ref(false)

let resizeObserver: ResizeObserver | null = null

const measure = () => {
   const element = textElement.value
   isTruncated.value = !!element && element.scrollWidth > element.clientWidth
}

onMounted(() => {
   measure()
   if (textElement.value) {
      resizeObserver = new ResizeObserver(measure)
      resizeObserver.observe(textElement.value)
   }
})

onBeforeUnmount(() => {
   resizeObserver?.disconnect()
})

watch(
   () => props.text,
   async () => {
      await nextTick()
      measure()
   }
)
</script>
